import { useParams } from 'react-router-dom';
import { useQuery, useConvexAuth } from 'convex/react';
import { api } from '../../../../backend/convex/_generated/api';
import type { Doc } from '../../../../backend/convex/_generated/dataModel';

export type WorkspaceWithRole = (Doc<"workspaces"> & { 
  role: string | null;
  organization?: Doc<"organizations"> | null;
}) | null;

export function useWorkspace(workspaceId?: string) {
  const { workspaceSlug } = useParams<{ workspaceSlug: string }>();
  const { isLoading: isAuthLoading, isAuthenticated } = useConvexAuth();
  
  // Use slug from URL if no ID is provided
  const workspaceBySlug = useQuery(api.workspaces.getBySlug, 
    (!workspaceId && workspaceSlug && !isAuthLoading) ? { slug: workspaceSlug } : "skip"
  );

  // Use ID if provided
  const workspaceById = useQuery(api.workspaces.get,
    (workspaceId && !isAuthLoading) ? { id: workspaceId as any } : "skip"
  );

  const workspace = workspaceId ? workspaceById : workspaceBySlug;

  return {
    workspace,
    isLoading: workspace === undefined || isAuthLoading,
    isAuthenticated,
    isAdmin: workspace?.role === "admin",
    isModerator: workspace?.role === "admin" || workspace?.role === "moderator",
  };
}

